export default "__VITE_ASSET__50806d5a__"